import merge from "lodash/merge"

import colors from "./colors"
import fonts from "./fonts"
import mixins from "./mixins"
import responsive from "./responsive"

const theme = merge({
  colors,
  fonts,
  mixins,
  responsive,
  sizes: {
    bioWidth: "290px",
    maxWidth: "1100px"
  },
})

export default theme
